<template>
    <div class="">
        <ContainerTitle icon="desktop" title="Administração"/>
        
        <div class="historico-beneficiario pt-0 pb-3 ">
            <CorrigirErrosInesperadosFilter :empresaSelected="this.filterForm.empresa" :empresaOptions="empresaOptions" :cleanFilter="cleanFilter" @filter-errors-inesperados="filtrar" />
            <CorrigirErrosInesperadosList :rows="rows" @filter-errors-inesperados="filtrar"/>

            <ModalAlert id="historico-beneficiario-list-vazio">
                <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
                Não existe beneficiários para o(s) filtro(s) selecionado(s).
            </ModalAlert>
            
            <PaginationTable :page="page" :totalPages="result.totalPages" />
        </div>

    </div>
</template>
<script>

import CorrigirErrosInesperadosFilter from './components/CorrigirErrosInesperadosFilter.vue'
import CorrigirErrosInesperadosList from './components/CorrigirErrosInesperadosList.vue'
import ModalAlert from "../../../../commons/ModalAlert.vue"
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import UserResource from "@/resources/UserResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import PaginationTable from "@/components/commons/table/components/PaginationTable.vue";


export default {
    name: 'CorrigirErrosInesperados',
    components: {
       CorrigirErrosInesperadosList,
       CorrigirErrosInesperadosFilter,
       ModalAlert,
       DynamicIcon,
       ContainerTitle,
       PaginationTable
    },
	data() {
		return {
            rows: [],
            result: {
				list: [],
				totalPages: 0,
				totalItens: 0
			},
			page: 1,
			filterForm: {
                empresa: null
            },
            cleanFilter: false,
            empresaOptions: []
		}
	},
    methods: {	
		changeNextPage( full = false ){
			if( this.page == this.result.totalPages ){
				return
			}

			!full ? this.page += 1 : this.page = this.result.totalPages
			this.filtrar()
		},
		changeBackPage( full = false ){
			if( this.page == 1 ){
				return
			}
			
			!full ? this.page -= 1 : this.page = 1
			this.filtrar()
		},
        filtrar(formFilter) 
        {
			this.lastFilter = {...formFilter}
			let filter = {
				page: this.page,
				...formFilter
			}

			BeneficiarioImportacaoResource.getLinesErrors(filter, {showLoader: true})
			.then((result) => {
                if(!Array.isArray(result.list))
                {
                    this.rows = [];
                }

                if(!result.list.length)
                {
                    this.$bvModal.show("historico-beneficiario-list-vazio");
                }

                this.rows = result.list.map( elem =>  { 
                    return {
                        ...elem,
                        importacaoId: elem.id.importacaoId, 
                        linha: elem.id.line, 
                        tipo: elem.tipoBeneficiario,
                        status: this.formatStatus(elem.flgAtivacao),
                    }
                })

				this.totalItens = result.totalItens
				this.totalPages = result.totalPages
				this.pageSize = result.pageSize
			})
            .catch(()=>{
                this.rows = []
            })
		},
        resetFilter()
        {
            this.cleanFilter = !this.cleanFilter
        },
        formatStatus(status)
        {
            if(status == 1)
                return "Ativo"
            
            return "Inativo"
        }
    },
    mounted() {
        UserResource.empresa(null,{ showLoader: false}).then(result => {
            if(Array.isArray(result))
            {
                this.filterForm.empresa = null
                this.empresaOptions = this.options = result.map(elem =>  Object.create({'value': elem.id, 'text': elem.text }) )
            }
            this.filtrar(this.filterForm);
        })
    }
}

</script>

<style scoped>
.historico-beneficiario {
	justify-content: space-between;
    color: #707070;
	font-size: 18px;
	text-align: left;
    background-color: #fff;
}

.total-itens{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.5% 0 0 1.2%;
    color: #002677;
    align-items:flex-start;
}
</style>